<template>
  <div>
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #f7f8fa" title="活动详情" left-arrow @click-left="$router.back()" />
    <div style="height:46px"></div>
    <div v-if="dataInfo.title">
      <img v-if="dataInfo.banner" :src="dataInfo.banner" alt="" style="width: 100%; display: block" />
      <div style="text-align: center; font-size: 16px; padding-top: 15px">{{ dataInfo.title }}</div>

      <div class="reward-tip" v-if="rewardTip">{{ rewardTip }}</div>

      <!-- 图片式：内容图按顺序展示 -->
      <div v-if="dataInfo.imgs && dataInfo.imgs.length">
        <img v-for="(im, i) in dataInfo.imgs" :key="i" :src="im" class="content-img" alt="" />
      </div>

      <!-- 富文本（可选，存在才显示） -->
      <template v-if="dataInfo.content">
        <van-divider dashed :style="{ color: '#000', borderColor: '#ccc', padding: '10px', width: '50%', margin: '0 auto' }">活动详情</van-divider>
        <div class="tables" v-html="dataInfo.content"></div>
      </template>
      <template v-if="dataInfo.memo">
        <van-divider dashed :style="{ color: '#000', borderColor: '#ccc', padding: '10px', width: '50%', margin: '0 auto' }">活动说明</van-divider>
        <div class="tables" v-html="dataInfo.memo"></div>
      </template>

      <div style="height: 120px"></div>
      <div class="bonsf">
        <div v-if="$store.state.token" class="btsdn" @click="onApplyClick">立即申请</div>
        <div v-else class="btsdn" @click="$parent.goNav('/login')">前往登录</div>
      </div>
    </div>

    <!-- 模式2：填申请金额 + 备注 -->
    <van-popup v-model="showApply" round position="bottom" :style="{ paddingBottom: '16px' }">
      <div class="apply-pop">
        <div class="apply-pop__title">填写申请信息</div>
        <van-field v-model="applyAmount" type="number" label="申请金额" placeholder="请输入申请金额" />
        <van-field v-model="applyRemark" label="备注" placeholder="选填：说明/联系方式" maxlength="100" />
        <div class="apply-pop__tip">提交后由管理员核实发放，实际到账以审核为准</div>
        <div class="apply-pop__btns">
          <div class="apply-pop__btn cancel" @click="showApply = false">取消</div>
          <div class="apply-pop__btn ok" @click="submitApply">提交申请</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return { dataInfo: {}, showApply: false, applyAmount: '', applyRemark: '' };
  },
  computed: {
    rewardTip() {
      let d = this.dataInfo;
      if (!d || !d.reward_mode) return '';
      if (d.reward_mode == 1) return '活动彩金 ' + (Number(d.reward_amount) || 0) + ' 元，审核通过后发放至中心钱包';
      if (d.reward_mode == 2) return '填写申请金额提交，管理员核实后发放至中心钱包';
      return '提交申请后，管理员审核并发放至中心钱包';
    },
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    onApplyClick() {
      let that = this;
      if (that.dataInfo.reward_mode == 2) {
        that.applyAmount = '';
        that.applyRemark = '';
        that.showApply = true;
      } else {
        that.doApply({});
      }
    },
    submitApply() {
      let that = this;
      let amt = Number(that.applyAmount);
      if (!amt || amt <= 0) {
        that.$parent.showTost(0, '请输入有效的申请金额');
        return;
      }
      that.doApply({ apply_amount: amt, remark: that.applyRemark });
    },
    doApply(extra) {
      let that = this;
      that.$parent.showLoading();
      let payload = Object.assign({ activityid: that.dataInfo.id }, extra || {});
      that.$apiFun
        .post('/api/doactivityapply', payload)
        .then(res => {
          that.$parent.hideLoading();
          that.showApply = false;
          that.$parent.showTost(res.code === 200 ? 1 : 0, res.message);
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.tables {
  font-size: 14px;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 1.5;
}
.content-img {
  width: 100%;
  display: block;
}
.reward-tip {
  margin: 12px 16px 0;
  padding: 10px 14px;
  font-size: 13px;
  color: #a05a00;
  background: #fff7e6;
  border: 1px solid #ffe0a3;
  border-radius: 8px;
  text-align: center;
}
.apply-pop {
  padding: 16px 0 0;
  &__title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
  }
  &__tip {
    font-size: 12px;
    color: #999;
    padding: 8px 16px 0;
  }
  &__btns {
    display: flex;
    gap: 12px;
    padding: 16px;
  }
  &__btn {
    flex: 1;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 100px;
    font-size: 15px;
    &.cancel {
      background: #f2f2f2;
      color: #666;
    }
    &.ok {
      color: #fff;
      background: linear-gradient(90deg, #ffac30, #fa436a, #f56c6c);
    }
  }
}
.bonsf {
  position: fixed;
  left: 5%;
  bottom: 10px;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 50px;
  background: hsla(0, 0%, 100%, 0.9);
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 50%);
  border-radius: 8px;
  .btsdn {
    display: flex;
    height: 38px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    box-shadow: 0 10px 20px -8px #fa436a;
    box-shadow: 1px 2px 5px rgb(219 63 96 / 40%);
    background: linear-gradient(90deg, #ffac30, #fa436a, #f56c6c);
    font-size: 14px;
    padding: 0 20px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityInfo.vue